var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRightSquare = function SvgArrowRightSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000B31",
    d: "M18.889 2.333H9.112c-4.247 0-6.778 2.532-6.778 6.779v9.765c0 4.258 2.531 6.79 6.778 6.79h9.765c4.247 0 6.778-2.532 6.778-6.779V9.112c.012-4.247-2.52-6.779-6.767-6.779m1.236 12.052a.88.88 0 0 1-.875.875.88.88 0 0 1-.875-.875v-3.523L9.37 19.868a.87.87 0 0 1-.619.257.87.87 0 0 1-.618-.257.88.88 0 0 1 0-1.236l9.007-9.007h-3.524a.88.88 0 0 1-.875-.875c0-.478.397-.875.875-.875h5.635c.479 0 .875.397.875.875z"
  })));
};
export default SvgArrowRightSquare;